import React from "react";
import { Row, Col, Modal, Button, Input, Form, Checkbox } from "antd";
import Close from "../../../../assets/images/close-x.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import data from "../../../../constants/retailPos.json";

const CashManagementModal = ({
  addCashFlag,
  setAddCashFlag,
  cashAddInFlag,
  cashManagementForm,
  handleCahInOut,
  onChangeCheckbox,
  posConfig,
  cashOut,
  pettyCashIn,
  cashIn,
  bankTransfer,
  handleManualDiscountKeyPress,
}) => {
  return (
    <Modal
      centered
      width="50%"
      styles={{ body: { padding: "1% 7%", background: "#f3f4f9" } }}
      footer={null}
      closeIcon={<img src={Close} alt="close" />}
      closable={true}
      onCancel={() => {
        cashManagementForm.resetFields();
        setAddCashFlag(false);
      }}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              fontWeight: "500",
              paddingTop: "2%",
              paddingLeft: "3%",
              color: "#0F0718",
            }}
          >
            {cashAddInFlag ? "Remove Cash" : "Add Cash"}
          </p>
        </div>
      }
    >
      <Form form={cashManagementForm} onFinish={handleCahInOut} layout="vertical">
        <Row style={{ padding: "3% 0 6% 0" }}>
          <Col span={13} style={{ paddingRight: "1vw" }}>
            {cashAddInFlag ? (
              <Row>
                <Col span={12}>
                  <Form.Item name={"cashOut"}>
                    {posConfig?.cashOut === "Y" ? (
                      <Checkbox style={{ fontWeight: 500 }} checked={cashIn} onChange={onChangeCheckbox}>
                        Cash Out
                      </Checkbox>
                    ) : null}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {posConfig?.allowPettyCashExpenses === "Y" ? (
                    <Form.Item name={"pettyCashOut"}>
                      <Checkbox checked={pettyCashIn} style={{ fontWeight: 500 }} onChange={onChangeCheckbox}>
                        Petty cash out
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
                <Col span={12}>
                  {posConfig?.enableBankTransferInCashOut === "Y" ? (
                    <Form.Item name={"bankTransfer"}>
                      <Checkbox checked={bankTransfer} style={{ fontWeight: 500 }} onChange={onChangeCheckbox}>
                        Bank Transfer
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={12}>
                  <Form.Item name={"cashIn"}>
                    {posConfig?.cashIn === "Y" ? (
                      <Checkbox style={{ fontWeight: 500 }} checked={cashIn} onChange={onChangeCheckbox}>
                        Cash In
                      </Checkbox>
                    ) : null}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {posConfig?.allowPettyCashIn === "Y" ? (
                    <Form.Item name={"pettyCashIn"}>
                      <Checkbox checked={pettyCashIn} style={{ fontWeight: 500 }} onChange={onChangeCheckbox}>
                        Petty cash In
                      </Checkbox>
                    </Form.Item>
                  ) : null}
                </Col>
              </Row>
            )}
            <Row>
              <Col span={24}>
                <Form.Item
                  className="popUpForm"
                  name="amount"
                  label={
                    <span
                      style={{
                        color: "#000",
                        fontSize: "1.2vw",
                        fontWeight: "500",
                      }}
                    >
                      Amount
                    </span>
                  }
                >
                  <Input
                    placeholder={`e.g, 100`}
                    size="large"
                    allowClear={false}
                    style={data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput}
                  />
                </Form.Item>
              </Col>
              <Col span={24} style={{ padding: "6% 0 3% 0" }}>
                <Form.Item
                  style={{ paddingBottom: 0 }}
                  className="popUpForm"
                  name="note"
                  label={
                    <span
                      style={{
                        color: "#000",
                        fontSize: "1.2vw",
                        fontWeight: "500",
                      }}
                    >
                      Note
                    </span>
                  }
                >
                  <Input placeholder={`Type to add a note`} size="large" allowClear={false} style={data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput} />
                  <p
                    style={{
                      marginBottom: "0px",
                      marginTop: "3px",
                      fontWeight: "500",
                      fontSize: "0.8vw",
                      color: "#929098",
                    }}
                  >
                    Max Characters : 200
                  </p>
                </Form.Item>
              </Col>
              <Col span={24} style={{ paddingBottom: "4%" }}>
                <Button
                  htmlType="submit"
                  style={{
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    width: "100%",
                    fontSize: "1.2vw",
                    textAlign: "center",
                    fontWeight: "400",
                    borderRadius: "3px",
                    height: "6vh",
                  }}
                >
                  Done
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={11}>
            <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 8]}>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("1")}>
                  1
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("2")}>
                  2
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("3")}>
                  3
                </button>
              </Col>

              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("4")}>
                  4
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("5")}>
                  5
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("8")}>
                  6
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("7")}>
                  7
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("8")}>
                  8
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("9")}>
                  9
                </button>
              </Col>

              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress(".")}>
                  .
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("0")}>
                  0
                </button>
              </Col>
              <Col span={8}>
                <button className="amt-dial-btn-super-market" onClick={() => handleManualDiscountKeyPress("x")}>
                  <img src={CancelArrow} alt="back space" width={20} height={15} />
                </button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row></Row>
      </Form>
    </Modal>
  );
};

export default CashManagementModal;
